import { Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintloanapplicationService } from "../../../shared/print/printloanapplication.service";

@Component({
  selector: 'app-rptloanpopup',
  templateUrl: './rptloanpopup.component.html',
  styleUrls: ['./rptloanpopup.component.css']
})
export class RptloanpopupComponent implements OnInit {

  LoanTypeList: any[]=[];
  SchemeList: any[]=[];
  BranchList: any[]=[];
  CentreList: any[]=[];
  CategoryList: any[]=[];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printloanapplicationService: PrintloanapplicationService) {}

  ngOnInit() {
    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    this.GetCentre();
    this.GetCategory();

    this.data.SchemeId = 0;
    this.data.TypeId = 0;
    this.data.LoanCategoryId = 0;
    this.data.CentreId = 0;
    this.data.BranchId = 0;
    this.data.StatusId = 0;
  }

  onNoClick(): void {
    this.printloanapplicationService.getRptLoanList(this.data);
    this.dialogRef.close();
  }
  
  GetScheme() {     
    this.CommonmastersService.FetchScheme().subscribe(data => {
    this.SchemeList = data;
  })
}

GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
    this.LoanTypeList = data;
  })
}

GetCategory() {
  this.CommonmastersService.GetCategoryList().subscribe(data => {
  this.CategoryList = data;
})
}

GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
    this.BranchList = data;
  })
}

GetCentre() {
  this.CommonmastersService.FetchCenterList().subscribe(data => {
  this.CentreList = data;
})
}

}
